import { type TFunction } from "i18next";

const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

/**
 * Coarse "how long ago" label for a visited-page row.
 *
 * The elapsed span is clamped at zero: a page recorded on the same tick the
 * popover opens can carry a timestamp a millisecond ahead of `nowMs`, which
 * would otherwise render as a negative count.
 */
export function formatRelativeVisit(nowMs: number, visitedAt: number, t: TFunction): string {
  const elapsed = Math.max(0, nowMs - visitedAt);
  if (elapsed < MINUTE_MS) return t("recentPages:time.justNow");
  if (elapsed < HOUR_MS) {
    return t("recentPages:time.minutes", { count: Math.floor(elapsed / MINUTE_MS) });
  }
  if (elapsed < DAY_MS) {
    return t("recentPages:time.hours", { count: Math.floor(elapsed / HOUR_MS) });
  }
  return t("recentPages:time.days", { count: Math.floor(elapsed / DAY_MS) });
}
